import React, { useEffect, useState } from 'react';
import styles from './UpgradeForMore.module.scss';
import icons from '../../assets';
import cx from 'classnames';
import { BigButton } from '../../common';
import { useNavigate } from 'react-router-dom';
import { selectPlanList } from '../../redux/slicers/subscriptionSlicer';
import { useSelector } from 'react-redux';
import ImagineLogo from '../../assets/images/imagine-logo.png';
import useCurrentOrganizationInfo from '../../hooks/useCurrentOrganizationInfo';
import { openFormInCaseOfNewOrgAndFreemiumUser } from '../../helpers/jsHelper';

const { CrossIcon, CheckMarkIcon, RadioIconFilled, RadioIcon } = icons;

const features = [
  '4K high resolution renders',
  'Unlimited rendering',
  'Fast previews without watermark',
  'Unlimited access to AI tools, and much more!',
];

const UpgradeForMore = ({ onClose, show = false, openInNewTab }) => {
  const params = new URLSearchParams(window.location.search);
  if (params.get('selectedInterval')) return null;
  const [selected, setSelected] = useState({});
  const [plans, setPlans] = useState([]);
  const plan = useSelector(selectPlanList)?.find(
    (_item) => _item?.pricing_details?.[0]?.is_self_serve_plan
  );
  const { hideNewPlans, isFreemiumUser } = useCurrentOrganizationInfo();

  useEffect(() => {
    if (hideNewPlans || isFreemiumUser) { // open enterprise form in case of freemium user whose org is created after 10th Feb 2025
      openFormInCaseOfNewOrgAndFreemiumUser();
      onClose?.();
    }
  }, [hideNewPlans,isFreemiumUser]);

  useEffect(() => {
    if (plan) {
      const finalPlans = plan?.pricing_details?.map((_item) => ({
        id: _item?.id,
        frequency: _item?.recurring_interval === 1 ? 'month' : 'year',
        price: parseInt(_item.unit_amount) / 100,
        title: _item?.recurring_interval === 1 ? 'Billed Monthly' : 'Billed Yearly',
        benefit: _item?.recurring_interval === 1 ? null : 'GET 2 MONTHS FREE',
        planId: plan?.id,
        recurring_interval: _item?.recurring_interval,
      }));

      setPlans(finalPlans);
      setSelected(finalPlans[1]);
    }
  }, [plan]);

  const navigate = useNavigate();

  const handleButtonClick = () => {
    const url = `/settings?activeTab=plans&selectedInterval=${selected.recurring_interval}`;
    openInNewTab ? window.open(url, '_blank') : navigate(url);
    onClose();
  };

  const handleFindMoreClick = () => {
    const url = `/settings?activeTab=plans`;
    openInNewTab ? window.open(url, '_blank') : navigate(url);
    onClose();
  };

  if (hideNewPlans || isFreemiumUser) { // hide this in case of freemium user whose org is created after 10th Feb 2025
    return null;
  }

  return (
    <div className={styles.container} style={{ display: plan ? 'flex' : 'none' }}>
      <div className={styles.closeIcon} onClick={onClose}>
        <CrossIcon />
      </div>
      <div className={styles.wrapper}>
        <aside className={styles.info}>
          <img className={styles.logo} src={ImagineLogo} />
          <div className={styles.planInfo}>
            <span>Creator plan</span>
            {features?.map((_item) => (
              <span key={_item} className="d-flex gap-3 align-items-center">
                <CheckMarkIcon />
                {_item}
              </span>
            ))}
          </div>
        </aside>
        <aside className={styles.action}>
          <div className="d-flex gap-2 flex-column">
            <div className={styles.title}>Upgrade for more</div>
            <div className={styles.subTitle}>
              Unlock premium benefits of imagine.io by upgrading your plan today
            </div>
          </div>
          <div className={styles.mainAction}>
            <span className={cx(styles.fs15, styles.fw500)}>Billing cycle</span>
            {plans?.map((_item) => (
              <div
                key={_item?.id}
                className={cx(styles.price, selected?.id === _item?.id ? styles.selected : '')}
                onClick={() => setSelected(_item)}>
                <div className="d-flex gap-2 w-100 align-items-center">
                  {selected?.id === _item.id ? <RadioIconFilled /> : <RadioIcon />}
                  <div className="d-flex justify-content-between w-100">
                    <div className="d-flex flex-column">
                      <span className={cx(styles.priceTitle, styles.fw500, styles.fs15)}>
                        {_item?.title}
                      </span>
                      <span className={styles.priceDetail}>
                        <span className={cx(styles.priceAmount, styles.fw500, styles.fs15)}>
                          ${_item?.price}
                        </span>
                        <span className={cx(styles.frequency, styles.fw500, styles.fs15)}>
                          /{_item?.frequency}
                        </span>
                      </span>
                    </div>
                    {_item.benefit ? (
                      <div className={styles.benefit}>
                        <span>{_item.benefit}</span>
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            ))}
          </div>
          <BigButton onClick={handleButtonClick} className={styles.button}>
            Upgrade plan
          </BigButton>
          <span
            className={cx(
              'w-100 d-flex align-items-center justify-content-center',
              styles.primaryText,
              styles.fw500,
              styles.fs15
            )}
            onClick={handleFindMoreClick}>
            Find out more
          </span>
        </aside>
      </div>
    </div>
  );
};

export default UpgradeForMore;
